import React, { useEffect, useMemo, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import { Toaster } from "@/components/ui/sonner";

function App() {
  // language is global; persisted in localStorage
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "ru";
    return localStorage.getItem("varenik_lang") || "ru";
  });

  useEffect(() => {
    localStorage.setItem("varenik_lang", lang);
  }, [lang]);

  const value = useMemo(() => ({ lang, setLang }), [lang]);

  return (
    <div className="App noise lace-bg min-h-screen">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing langCtx={value} />} />
          <Route path="/admin" element={<Landing langCtx={value} adminInitialOpen={true} />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="top-center" />
    </div>
  );
}

export default App;
